<template>
    <div>
        <Row :gutter="16">

            <Col span="18">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row style="text-align:center;margin-bottom:10px;">
                        <transition name="fade" mode="out-in">
                            <img v-show="curImage !== null" :src="curImage"
                                 style="max-width:100%;max-height:100%;"/>
                        </transition>
                    </Row>
                    <Row style="text-align:center;margin-bottom:10px;">
                        <Button v-for="imageSize in imageSizeList" :key="imageSize.range" type="success"
                                size="small"
                                style="margin-right:10px;"
                                @click="onImageSizeBtnClick(imageSize)">{{ imageSize.name }}
                        </Button>
                    </Row>
                    <Row>
                        <Form :model="formItem" :label-width="105" label-position="right">
                            <FormItem :label="t.article.category" prop="dictId">
                                <Input v-model="currentDictArticleInfo.label" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.thumb" prop="thumb">
                                <Input v-model="formItem.thumb" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.default" prop="image">
                                <Input v-model="formItem.image" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.top" prop="top">
                                <Input v-model="formItem.top" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.hot" prop="hot">
                                <Input v-model="formItem.hot" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.recommend" prop="recommend">
                                <Input v-model="formItem.recommend" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.recommendTop" prop="recommendTop">
                                <Input v-model="formItem.recommendTop" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.topic" prop="topic">
                                <Input v-model="formItem.topic" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.slider" prop="slider">
                                <Input v-model="formItem.slider" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.releaseTime" prop="releaseTime">
                                <Input v-model="formItem.releaseTime" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.title" prop="title">
                                <Input v-model="formItem.title" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.author" prop="author">
                                <Input v-model="formItem.author" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.description" prop="description">
                                <Input v-model="formItem.description" type="textarea" :rows="4" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.article.body">
                                <tinymce id="id1" v-model="formItem.body" :toolbar1="toolbar1"
                                         :other_options="other_options" readonly></tinymce>
                            </FormItem>
                        </Form>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Row>
                    <Card>
                        <p slot="title">
                            <Icon type="logo-buffer"/>
                            {{t.menu.title}}
                        </p>
                        <Tree ref="tree" :data="menuList"></Tree>
                    </Card>
                </Row>
                <Row class="margin-top-10">
                    <Card style="font-size: 12px;">
                        <p slot="title">
                            <Icon type="ios-paper-plane-outline"/>
                            {{t.menu.setting}}
                        </p>
                        <Row class="margin-bottom-10" type="flex" align="middle">
                            <Col span="4" offset="2">{{t.article.tag}}</Col>
                            <Col span="18">
                                <span v-for="item in tagList" :value="item.id" :key="item.id">
                                    <Tag type="border">{{ item.name }}</Tag>
                                </span>
                            </Col>
                        </Row>
                        <Row class="margin-bottom-10" type="flex" align="middle">
                            <Col span="4" offset="2">{{t.article.hits}}</Col>
                            <Col span="18">
                                <Tag type="border">{{ formItem.hits }}</Tag>
                            </Col>
                        </Row>
                        <Row class="margin-bottom-10" type="flex" align="middle">
                            <Col span="4" offset="2">{{t.article.status}}</Col>
                            <Col span="18">
                                <Tag type="border">{{ formItem.status }}</Tag>
                            </Col>
                        </Row>
                        <Row class="margin-bottom-10" type="flex" align="middle">
                            <Col span="4" offset="2">{{t.article.charge}}</Col>
                            <Col span="18">
                                <Tag type="border">{{ formItem.charge }}</Tag>
                            </Col>
                        </Row>
                        <Row type="flex" align="middle">
                            <Col span="4" offset="2">{{t.article.disabled}}</Col>
                            <Col span="18">
                                <Tag type="border">{{ formItem.disabled }}</Tag>
                            </Col>
                        </Row>
                    </Card>
                </Row>
            </Col>

        </Row>
    </div>
</template>

<script>
import { getTreeMenuList } from '@/api/menu';
import { getTagList } from '@/api/tag';
import { add, getArticleInfo, getImageSizeInfo } from '@/api/article';
import { getDictArticleList } from '@/api/dict';

export default {
    name: 'content_article_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            self: this,
            msgUtil: msgUtil,
            imageSizeList: [],
            dictArticleList: [],
            curImage: null,
            currentDictArticleInfo: {
                label: '',
            },
            formItem: {
                title: '',
                author: '',
                thumb: null,
                image: null,
                description: '',
                body: '',
                version: 1,
                hot: null,
                recommend: null,
                recommendTop: null,
                topic: null,
                top: null,
                slider: null,
                hits: 0,
                charge: '1',
                status: '0',
                disabled: '1',
                selectedMenuId: '',
                tagIdList: [],
                releaseTime: '',
            },
            toolbar1: 'newnote print preview code',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
            },
            paramTag: {
                status: '1',
                size: '99999',
            },
            paramMenuTree: {
                division: '1',
            },
            menuList: [],
            tagList: [],
            loading: false,
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    beforeDestroy() {
        //console.log(this.$refs.tree);
        //this.$refs.tree.destroy();
    },
    methods: {
        onImageSizeBtnClick(val) {
            let data = {};
            if (this.currentDictArticleInfo.label !== '') {
                data = this.currentDictArticleInfo;
            } else {
                data = this.formItem;
            }
            if (val.range === 'image') {
                this.curImage = data.image;
            } else if (val.range === 'thumb') {
                this.curImage = data.thumb;
            } else if (val.range === 'slider') {
                this.curImage = data.slider;
            } else if (val.range === 'recommendTop') {
                this.curImage = data.recommendTop;
            } else if (val.range === 'recommend') {
                this.curImage = data.recommend;
            } else if (val.range === 'hot') {
                this.curImage = data.hot;
            } else if (val.range === 'topic') {
                this.curImage = data.topic;
            } else if (val.range === 'top') {
                this.curImage = data.top;
            }
        },
        //被选中的角色权限匹配映射
        setSelectedMenuId(nodeElement) {
            for (let i = 0; i < nodeElement.length; i++) {
                nodeElement[i].disabled = true;
                if (nodeElement[i].children !== undefined && nodeElement[i].children.length > 0) {
                    this.setSelectedMenuId(nodeElement[i].children);
                    continue;
                } else {
                    nodeElement[i] = { title: nodeElement[i].title, id: nodeElement[i].id, disabled: true };
                }
                if (this.formItem.selectedMenuId === nodeElement[i].id) {
                    nodeElement[i].selected = true;
                }
            }
        },
    },
    async mounted() {
        //得到图片大小情报
        const imageSizeInfo = await getImageSizeInfo();
        if (imageSizeInfo.imageSizeList != null) {
            this.imageSizeList = imageSizeInfo.imageSizeList;
        }

        //得到字典数据
        const dictArticles = await getDictArticleList();
        let dictArticleList = [];
        if (dictArticles.dicts != null) {
            dictArticleList = dictArticles.dicts;
        }

        //得到文章情报
        const articleInfo = await getArticleInfo(this.$route.params.id);
        if (articleInfo.article != null) {
            this.formItem = articleInfo.article;
            if (this.formItem.status === '0') {
                this.formItem.status = this.t.article.status0;
            } else if (this.formItem.status === '1') {
                this.formItem.status = this.t.article.status1;
            } else if (this.formItem.status === '2') {
                this.formItem.status = this.t.article.status2;
            } else if (this.formItem.status === '9') {
                this.formItem.status = this.t.article.status9;
            }

            if (this.formItem.charge === '0') {
                this.formItem.charge = this.t.article.charge1;
            } else if (this.formItem.charge === '1') {
                this.formItem.charge = this.t.article.charge0;
            }

            if (this.formItem.disabled === '0') {
                this.formItem.disabled = this.t.article.yes;
            } else if (this.formItem.disabled === '1') {
                this.formItem.disabled = this.t.article.no;
            }
            for (let i = 0; i < dictArticleList.length; i++) {
                if (dictArticleList[i].id === this.formItem.dictId) {
                    this.currentDictArticleInfo = dictArticleList[i];
                    break;
                }
            }
        }
        //得到前台所有菜单展示
        const treeMenuList = await getTreeMenuList(this.paramMenuTree);
        if (treeMenuList.menus != null) {
            this.menuList = treeMenuList.menus;
            this.setSelectedMenuId(this.menuList);
        }
        //得到标签数据集
        const tagList = await getTagList(this.paramTag);
        if (tagList.page != null) {
            this.tagList = tagList.page.records.filter(item => this.formItem.tagIdList.includes(item.id));
        }
        //默认表示索引为0的图片
        this.onImageSizeBtnClick(this.imageSizeList[0]);
    },
};
</script>
<style lang="less" scoped>
</style>
